export default class LocationAvailabilitySettingsModel {
    providers: string[] | null = null;
    pickUpLocationIds: string[] | null = null;
    lor: number | null = null;
    pos: string | null = null;
    country: string | null = null;
}
